export const buildCriteriaKey = (category, id) => `${category}:${id}`;

export const keepCriteriaKeys = (values) => (Array.isArray(values) ? values : []).filter((value) => typeof value === "string" && value.includes(":"));
